"use strict";

import NiceSelect from "nice-select2/dist/js/nice-select2.js";
import {slideUp,slideDown, slideToggle} from "../lib/slideUpDown.js";

const mobileBreak = 1300;
const pixelRatio = navigator.userAgent.indexOf('Mac OS X') !== -1 ? 2 : 1.25;

const toggleMenu = function () {
    const burger = document.querySelector(".burger");
    const menuItems = document.querySelectorAll(".main-nav a");
    const body = document.body;

    if (burger) {
        burger.initLabel = burger.querySelector('span').innerText;
        burger.openedLabel = burger.dataset.opened_label;

        burger.addEventListener('click', (event) => {
            event.preventDefault();
            const that = event.currentTarget;
            const txtContainer = that.querySelector('span');

            body.classList.toggle('menu-active');

            if (body.classList.contains('menu-active')) {
                that.ariaExpanded = true;
                txtContainer.innerText = that.openedLabel;
            } else {
                that.ariaExpanded = false;
                txtContainer.innerText = that.initLabel;
            }
        });
    }

    if (menuItems.length) {
        menuItems.forEach((item) => {

            item.addEventListener("click", () => {
                const parent = item.parentElement;

                if(parent.classList.contains('menu-item-has-children')){
                    item.classList.toggle('active');
                }

                if (!parent || !parent.querySelector("ul")) {
                    body.classList.remove("menu-active");
                    burger.setAttribute("aria-expanded", "false");
                }
            });

            item.addEventListener("keydown", (event) => {

                if (event.key === " " || event.code === "Space" || event.keyCode === 32) {
                    event.preventDefault();
                }

                if (event.key == "ArrowRight" || event.keyCode == 39 || event.key == "ArrowLeft" || event.keyCode == 37) {
                    event.preventDefault();

                    const parentLI = item.closest('.menu-item-has-children');

                    if (parentLI) {
                        const parentSibling = event.keyCode === 39 ? parentLI.nextElementSibling : parentLI.previousElementSibling;
                        if (parentSibling) parentSibling.querySelector('a').focus();
                    }
                }

                if (event.key == "Escape" || event.keyCode == 27) {
                    event.preventDefault();
                    const skipper = document.querySelector('.skip-to-main-content-link[href="#main-content"]');
                    if (skipper) skipper.click();
                }

            });
        });
    }
};

const scrollDetector = function () {

    const body = document.querySelector('body');
    const headerHead = document.querySelector('.header-head');
    const headerMain = document.querySelector('.header-main');

    let timer;
    let flag = false;

    window.onscroll = getScrollPosition;
    getScrollPosition();

    function getScrollPosition(){

        const scrollObject = window.pageYOffset;

        if(scrollObject > 20){
            body.classList.add('scrolled');
        }else{
            body.classList.remove('scrolled');
        }

        if(headerHead){

            const rect = headerHead.getBoundingClientRect();

            if(rect.bottom <= 0){

                if(!body.classList.contains('glue-menu')){
                    body.classList.add('glue-menu');
                    body.style.paddingTop = headerMain.offsetHeight + 'px';
                }

            }else{

                body.classList.remove('glue-menu');
                body.style.paddingTop = '';

            }
        }

        if (body.classList.contains('searchbox-active') && window.innerWidth >= mobileBreak) {

            body.classList.remove('searchbox-active');

            const searchBtn = document.querySelector('.search-btn__btn');
            const searchbox = document.querySelector('.searchbox');

            if (searchBtn && searchbox) {
                const searchField = searchbox.querySelector('input[type=search]');
                const txtContainer = searchBtn.querySelector('.screen-reader-text');

                searchBtn.ariaExpanded = false;
                txtContainer.innerText = searchBtn.openedLabel;

                searchField.blur();
            }
        }
    }

    window.addEventListener('scroll', function () {

        if (!flag) {
            flag = true;
            body.classList.add('scrolling');
        }

        clearTimeout(timer);

        timer = setTimeout(function () {
            body.classList.remove('scrolling');
            flag = false;
        },1000);

    });
};

const languageSwitcher = () => {

    const select = document.querySelector(".pll-switcher-select");

    if(!select) return;

    if (window.innerWidth >= mobileBreak || (window.devicePixelRatio > pixelRatio && window.innerWidth >2200)) {
        NiceSelect.bind(select,{searchable:false});
    }

    select.addEventListener("change",(e)=>{
        const val = e.currentTarget.value;
        if (val !== "") window.location.href = val;
    });

};

const toggleSearchBar = function () {

    const searchBtn = document.querySelector('.search-btn__btn');
    const searchbox = document.querySelector('.searchbox');
    const searchField = searchbox.querySelector('input[type=search]');
    const body = document.querySelector('body');

    if (searchBtn && searchbox && searchField) {

        const txtContainer = searchBtn.querySelector('.screen-reader-text');
        searchBtn.openedLabel = txtContainer.innerText;

        searchBtn.addEventListener('click', function (e) {

            e.preventDefault();
            body.classList.toggle('searchbox-active');

            if (body.classList.contains('searchbox-active')) {

                body.classList.remove('menu-active');
                this.ariaExpanded = true;
                txtContainer.innerText = this.dataset.alt_txt;

            } else {

                this.ariaExpanded = false;
                txtContainer.innerText = this.openedLabel;

            }

            searchBtn.focus();

        });

    }
};

const toggleSubMenu = function () {

    const menuItems = document.querySelectorAll('html:not(.dark-theme) .main-nav > li > a');
    const body = document.querySelector('body');

    if(menuItems){

        [...menuItems].map((item)=>{

            item.addEventListener('click', function (e){

                const parent = this.parentElement;

                if((window.innerWidth <= mobileBreak || (window.devicePixelRatio > pixelRatio && window.innerWidth <2200)) && parent.classList.contains('menu-item-has-children')){

                    if(!parent.classList.contains('focus')){
                        e.preventDefault();
                    }else{
                        body.classList.remove('menu-active');
                        looseFocus();
                    }

                    looseFocus();
                    parent.classList.toggle('focus');

                }

            });

        });

    }
};

const hoverSubMenu = function () {

    const items = document.querySelectorAll('.main-nav > li.menu-item-has-children');
    if (!items.length) return;

    let overlayTimer;

    const closeControls = () => {
        document.querySelectorAll('.menu-control.opened').forEach(control => {
            const button = control.querySelector('button');
            const dropdown = control.querySelector('.menu-control__dropdown');

            control.classList.remove('opened');

            if (button) button.setAttribute('aria-expanded', 'false');

            if (dropdown) {
                dropdown.setAttribute('aria-hidden', 'true');
                dropdown.style.height = 0;
            }
        });
    };

    const isMobileMode = () => {
        return window.innerWidth <= mobileBreak || (window.devicePixelRatio > pixelRatio && window.innerWidth < 2200);
    };

    items.forEach(item => {

        const submenu = item.querySelector('.main-nav__sub-menu');
        if (!submenu) return;

        item.addEventListener('mouseenter', () => {
            if (isMobileMode()) return;

            clearTimeout(overlayTimer);
            closeControls();

            item.classList.add('opened');
            item.setAttribute('aria-expanded', 'true');

            submenu.style.height = 'auto';
            const trueHeight = submenu.scrollHeight;
            submenu.style.height = '0';
            submenu.offsetHeight;

            submenu.style.height = trueHeight + 'px';
            submenu.setAttribute('aria-hidden', 'false');

            document.body.classList.add('menu-overlay');

            requestAnimationFrame(() => {
                document.body.classList.add('anim');
            });

        });

        item.addEventListener('mouseleave', () => {
            if (isMobileMode()) return;

            item.classList.remove('opened');
            item.setAttribute('aria-expanded', 'false');

            submenu.style.height = 0;
            submenu.setAttribute('aria-hidden', 'true');

            document.body.classList.remove('anim');

            overlayTimer = setTimeout(() => {
                if (!document.querySelector('.menu-control.opened') &&
                    !document.querySelector('.main-nav > li.opened')) {
                    document.body.classList.remove('menu-overlay');
                }
            }, 500);

        });

        const link = item.querySelector('a');

        link.addEventListener('focus', () => {
            if (isMobileMode()) return;

            item.classList.add('opened');
            item.setAttribute('aria-expanded', 'true');

            submenu.style.height = 'auto';
            const trueHeight = submenu.scrollHeight;
            submenu.style.height = '0';
            submenu.offsetHeight;

            submenu.style.height = trueHeight + 'px';
            submenu.setAttribute('aria-hidden', 'false');

        });

    });

    document.addEventListener('focusin', (e) => {
        if (isMobileMode()) return;

        const open = document.querySelector('.main-nav li.opened');

        if (!open) return;

        if (!open.contains(e.target)) {

            const submenu = open.querySelector('.main-nav__sub-menu');

            open.classList.remove('opened');
            open.setAttribute('aria-expanded', 'false');

            if (submenu) {
                submenu.style.height = 0;
                submenu.setAttribute('aria-hidden', 'true');
            }

        }

    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {

            document.querySelectorAll('.main-nav li.opened').forEach(item => {

                const submenu = item.querySelector('.main-nav__sub-menu');

                item.classList.remove('opened');
                item.setAttribute('aria-expanded', 'false');

                if (submenu) {
                    submenu.style.height = 0;
                    submenu.setAttribute('aria-hidden', 'true');
                }

            });

            document.body.classList.remove('menu-overlay');
            document.body.classList.remove('anim');

        }
    });

};

const looseFocus = () => {

    [...document.querySelectorAll('.focus')].map((item)=>{
        item.classList.remove('focus');
    });

};

export {
    toggleMenu,
    scrollDetector,
    languageSwitcher,
    toggleSearchBar,
    toggleSubMenu,
    hoverSubMenu
};